<template>
  <!-- 2カラムページの場合は'is-2column'クラスを付与 -->
  <!-- ヘッダーを隠すの場合は'is-hidden-header'クラスを付与 -->
  <div id="body"
    :class="{'is-hidden-header' : targetScrollFlg}"
    @scroll="handleScroll"
  >
  <BackgroundImage />

    <!-- menu:start -->
    <PCMenu
      class="visible"
      v-if="visibleMenu"
      @closeMenu="visibleMenu = false"
    />
    <!-- menu:end -->

    <div id="wrapper">
      <!-- header:start -->
      <header id="header" class="header">
        <PCButtonHistoryBack />
      </header>
      <!-- header:end -->

      <!-- menu-bar:start -->
      <!-- open -->
      <div class="menu-bar" role="button" 
        :class="{'is-open' : !targetScrollFlg}"
        @click="visibleMenu = !visibleMenu"
      >
        <IconMenu class="icn" 
          v-if="!targetScrollFlg"
        />
        <FontawesomeIcon :icon="['far','chevron-up']" size="lg" class="icn"
          v-if="targetScrollFlg"
        />
      </div>
      <!-- close -->
      <!-- menu-bar:end -->

      <!-- content:start -->
      <div id="content"
        style="height:calc(100vh - 84px);"
      >
        <div class="contact"
          @scroll="handleScroll"
        >
          <div class="contact-head">
            <div class="breadcrumb">
              <span class="breadcrumb-link current">お見積もりのご依頼</span> ／ <span class="breadcrumb-link">お見積もりご依頼内容の確認</span> ／ <span class="breadcrumb-link">お見積もりご依頼の完了</span>
            </div>
            <h1 class="hdg02">お見積もりのご依頼</h1>
          </div>
          <form @submit.prevent class="contact-container">
            <div class="contact-content">
              <p class="txt" :class="group1.isError ? 'mb20' : 'mb40'">必要事項をご記入いただきお見積もり依頼を送信してください。<br>ご登録のメールアドレスへ「お見積りのご案内」を送信いたします。</p>
              <p class="error-message mb40" v-if="group1.isError">入力内容に不備があるようです。下記メッセージ（赤文字）のご確認をお願いいたします。</p>

              <h2 class="hdg03 mb28">お見積もりフォーム</h2>
              <ul class="contact-content-list">
                <li class="contact-content-list-item">
                  <table class="contact-content-table contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th class="border-none">
                          <span class="contact-content-table-hdg">弊社社員からの紹介であれば社員名を入力してください</span>
                        </th>
                        <td class="border-none">
                          <div class="formparts text mb12" style="max-width:480px;">
                            <input type="text" v-model="group1.introducer" placeholder="山田太郎">
                          </div>
                          <p class="txt-sup">
                            不明の場合は入力不要です。<br>この欄に弊社社員名以外の入力をされてもご対応致しかねます。
                          </p>
                          <p class="error-message" v-if="group1.error_introducer">{{group1.error_introducer}}</p>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
                <li class="contact-content-list-item">
                  <table class="contact-content-table contact-content-table">
                    <colgroup>
                      <col style="width:30%;">
                      <col sytle="width:70%;">
                    </colgroup>
                    <tbody>
                      <tr>
                        <th class="border-none">
                          <span class="contact-content-table-hdg">備考</span>
                        </th>
                        <td class="border-none">
                          <div class="formparts textarea">
                            <textarea v-model="group1.note" rows="5" placeholder="ご質問などがありましたら、ご入力ください。"></textarea>
                            <p class="error-message" v-if="group1.error_note">{{group1.error_note}}</p>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </li>
              </ul>
              <h2 class="hdg03 mb28">見積もりを希望するパッケージ / 商品</h2>
              <p class="contact-content-lead">見積もりを希望する「パッケージ/商品」の「見積もり」ボタンを押下後、利用を希望するライセンス数（人数）をご指定ください。</p>
              <ul class="contact-content-note mb32">
                <li>パッケージによっては、ご購入いただけるライセンス数をあらかじめ設定しているものがございます。</li>
              </ul>

              <p class="error-message" v-if="group1.error_productsLicenses">{{group1.error_productsLicenses}}</p>

              <FontawesomeIcon v-if="!group1.isPackageAndLicensesLoaded" :icon="['fal','spinner-third']" size="2x" class="mb12 icn fa-spin" />
              <template v-else>
                <p v-if="group1.packagesAndProducts.length === 0">表示する内容がありません。</p>
                <template v-else>

                  <table class="license-content-table border mb60">
                    <colgroup>
                      <col style="width:20%;">
                      <col sytle="width:40%;">
                      <col sytle="width:20%;">
                      <col sytle="width:15%;">
                      <col sytle="width:5%;">
                    </colgroup>
                    <thead>
                      <tr>
                        <th>パッケージ</th>
                        <th>商品</th>
                        <th></th>
                        <th class="ta-center">ライセンス数を指定</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in group1.packagesAndProducts" :key="'packages_products_' + index">
                        <th v-if="item.is_first" :rowspan="item.products_count">
                          <div class="license-content-table-hdg">{{ item.package_name }}</div>
                        </th>
                        <td :class="item.is_first ? '' : 'pl20'">
                          <div class="license-content-table-title" :class="{'is-inactive': !item.is_buyable}">{{ item.product_name }}</div>
                          <div v-if="!item.is_buyable" class="contact-content-table-sup mt12">{{ item.package_name }}を購入していないため、購入できません。</div>
                        </td>
                        <td>
                          <div v-if="!item.is_bought && item.is_buyable" class="license-content-table-link">
                            <span @click="group1.onBuyButonClicked({item: item})" role="button">見積もり</span>
                          </div>
                        </td>
                        <td>
                          <div class="license-content-table-select">
                            <span v-if="!item.is_bought">-</span>
                            <div v-else
                              class="formparts select"
                              @mouseenter="group1.onMouseEnterLicenseSelectItem(item)"
                              @mouseleave="group1.onMouseLeaveLicenseSelectItem(item)"
                              :class="{ 'is-visible-list': item.display_licenses_select }"
                            >
                              <div class="select-label ta-center" role="select">{{ item.licenses }}<FontawesomeIcon :icon="item.display_licenses_select ? 'angle-up' : 'angle-down'" class="icn" /></div>
                              <div class="select-option">
                                <ul class="select-option-list ta-center">
                                  <template v-for="n of 99">
                                    <li :key="n" v-if="n >= item.fixed_licenses" class="ta-center" role="option">
                                      <label><input type="radio" :name="`product-${ item.product_id }`" :value="n" @change="group1.onLicensesChoicesChanged({item: item, licenses: n})">{{ n }}</label>
                                    </li>
                                  </template>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div v-if="item.is_bought"
                            @click="group1.onResetButtonClicked({item: item})"
                            class="license-content-table-reset" role="button"
                          >
                            <div class="license-content-table-reset-tip">リセット</div>
                            <FontawesomeIcon :icon="['far','eraser']" size="lg" class="icn"/>
                          </div> 
                        </td>
                      </tr>
                    </tbody>
                  </table>

                </template>
              </template>

              <div class="contact-submit mb60">
                <div class="button contact-submit-button">
                  <button class="btn" @click="group1.onSubmitButtonClicked">次へ</button>
                </div>
              </div>
              
            </div>
          </form>
        </div>
      </div>
      <!-- content:end -->
    </div>
  </div>
</template>
<script>
import { defineComponent, reactive, ref, computed, onMounted } from '@vue/composition-api'
import store from '@/store'
import PCMenu from '@/components/pc/popup/PCMenu.vue'
import * as logicLoggedinEstimate from '@/logic/estimate/LoggedinEstimate'

export default defineComponent({
  components: {
    PCMenu
  },
  beforeRouteEnter (to, from, next) {
    if (from.name !== 'PCEstimateConfirm') {
      // 確認画面以外から遷移して来た場合はストアに保持している値を全クリア
      store.dispatch('inquiry/clearAllStates')
    }
    next()
  },
  setup (props, context) {

    onMounted(() => {
      // 初期表示
      group1.init()
    })

    const group1 = logicLoggedinEstimate.getGroupIndex(props, context)

    return {
      group1
    }
  }
})
</script>

<style lang="scss" scoped>
#content {
  background-color: #fff;
  border-radius: 8px 8px 0 0;
  margin-bottom: 60px;
  overflow-y: auto;
}
.breadcrumb {
  color: $color-content;
  font-size: 1.4rem;
  margin-bottom: 16px;
  &-link {
    color: $color-inactive;
    &.current {
      color: $color-content;
    }
  }
}
.contact {
  width: 100%;
  overflow: auto;
  &-container {
    border-top: 1px solid $color-line;
    padding: 40px 0;
    .button .btn[type="submit"] {
      width: 230px;
      margin: 32px auto 0;
    }
  }
  &-head {
    padding: 40px;
    [class^="hdg"] {
      margin-bottom: 0;
    }
  }
  &-content {
    max-width: 1105px;
    padding: 0 40px;
    margin: 0 auto;
    &-lead{
      padding: 30px 0 0;
      border-top: 1px solid $color-line;
      font-size: 1.8rem;
      color: #555;
    }
    &-note{
      margin-top: 12px;
      font-size: 1.4rem;
      color: #999;
      list-style: none;
    }
    &-list {
      list-style: none;
      margin-bottom: 32px;
      &-item {
        border-top: 1px solid $color-line;
        padding: 32px 0;
        &.border-top-none{
          border-top: none;
        }
        .contact-content-table {
          th,td {
            padding: 0 20px;
          }
        }
      }
    }
    &-table {
      width: 100%;
      border-collapse: collapse;
      .border-none {
        border: 0!important;
      }
      &.border-bottom {
        border-bottom: 1px solid $color-line;
      }
      thead {
        th {
          color: $color-sup;
          font-size: 1.6rem;
          font-weight: normal;
          padding: 16px 20px;
        }
      }
      tbody {
        // th {
        //   vertical-align: baseline;
        // }
        th,td {
          padding: 16px 20px;
          border-top: 1px solid $color-line;
          vertical-align: baseline;
        }
      }
      &-hdg {
        display: block;
        color: $color-hdg;
        font-size: 1.6rem;
        font-weight: bold;
        &.is-inactive {
          color: $color-inactive;
        }
      }
      &-sup {
        color: $color-sup;
        font-size: 1.4rem;
      }
      &-btnarea {
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        position: relative;
        .contact-content-table-link {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translate3d(0,-50%,0);
          &-tip {
            position: absolute;
            top: -20px;
            left: -8px;
            white-space: nowrap;
            font-size: 1.4rem;
            transition: all .2s;
            opacity: 0;
          }
          &:hover {
            box-shadow: 0px 3px 6px rgba(0,0,0,.16);
            .contact-content-table-link-tip {
              opacity: 1;
            }
          }
        }
      }
      &-btn {
        width: 160px;
        .formparts.select .select-label,
        .button .btn {
          height: 32px;
        }
      }
      &-link {
        font-size: 1.6rem;
        color: $color-link;
        padding: 10px;
        border-radius: 4px;
        @include hoverOpacity;
      }
      // &-list {
      //   li {
      //     padding-left: 10px;
      //   }
      //   .checkbox {
      //     padding: 12px 0;
      //   }
      //   .textarea {
      //     textarea {
      //       width: 100%;
      //     }
      //   }
      //   &-parts {
      //     display: flex;
      //     align-items: center;
      //     padding: 12px 0 12px 30px;
      //     .txt,
      //     .select {
      //       display: inline-block;
      //       margin-right: 12px;
      //       margin-bottom: 0;
      //     }
      //     .select-label {
      //       height: 32px;
      //     }
      //   }
      // }
      .txt-blue {
        @include hoverOpacity;
      }
    }
  }
  &-submit {
    width: 230px;
    margin: 32px auto 0;
  }
}
.list-inline {
  a {
    @include hoverOpacity;
  }
}
.footer {
  margin-top: 72px;
  margin-bottom: 40px;
  text-align: center;
  a {
    font-size: 1.2rem;
  }
}
</style>
